module.exports = __webpack_public_path__ + "static/media/new-logo.65b9bb6d.svg";